import { Box, Button, Grid, MenuItem, Paper, Card, CardContent, FormControl, TextField } from "@material-ui/core";
import { AccessTime, DirectionsRun } from "@material-ui/icons";
import React, { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import Swal from "sweetalert2";
import { getBuildingSettingOption } from "../../../../api/buildingSettingApi";
import {
    getDoctorQueue,
    getDoctorQueueDisplay,
    getLabAndXray,
    getQueueRoom,
    updateDoctorQueueById,
} from "../../../../api/queueApi";
import Color from "../../../../styles/Color";
import { useForceRender } from "../../../../utils/customHook";
import SelectDropOtions from "../../../components/SelectDropOtions";
import { useStyles } from "./helpers/QueueManageEvent";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { parseJsonStr } from "../../../../utils/formatHelper";

const initialStateActionDropdown = {
    building: "",
    floor: "",
};

const initialDoctorQueue = {
    queueWait: [],
    queueInRoom: {
        doctorQueueId: "",
        QueueNo: "",
        ServingTime: "",
        Service: "",
        Status: "",
        DoctorName: "",
        TypePatient: "",
        PatientName: "",
    },
    queueHold: [],
    queueWaitPage: 1,
    queueWaitPerPage: 5,
    queueHoldPage: 1,
    queueHoldPerPage: 5,
    totalQueueWait: 0,
    totalQueueHold: 0,
};

function QueueManagement() {
    const useClass = useStyles();
    const [render, forceRender] = useForceRender();

    // ref
    const controllerRef = useRef(null);

    // component state
    const [socketIO, setSocketIO] = useState(null);
    const [isAllactionDD, setIsAllactionDD] = useState(initialStateActionDropdown);
    const [roomValue, setRoomValue] = useState({ idx: 0, roomObj: {} });
    const [queueTypeTab, setQueueTypeTab] = useState({ idx: 0, type: "Wait" });
    const [option, setOption] = useState({ building: [], floor: [] });
    const [doctorRoom, setDoctorRoom] = useState([]);
    const [doctorQueue, setDoctorQueue] = useState(initialDoctorQueue);
    const [searchQueueText, setSearchQueueText] = useState("");
    const [showMoreIcon, setShowMoreIcon] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRecalling, setIsRecalling] = useState(false);
    const [isCalling, setIsCalling] = useState(false);
    const [callingIndex, setCallingIndex] = useState(null);
    const [isHoldingWaitQueue, setIsHoldingWaitQueue] = useState(false);
    const [holdingWaitQueueIndex, setHoldingWaitQueueIndex] = useState(null);
    const [isEnterSelectRoom, setIsEnterSelectRoom] = useState(false);

    // get queue in room
    const getDoctorQueueByRoomId = async roomId => {
        try {
            const queryParams = {
                roomId,
                queueWaitPage: 1,
                queueWaitPerPage: 4,
                queueHoldPage: 1,
                queueHoldPerPage: 4,
            };
            const res = await getDoctorQueueDisplay(queryParams, controllerRef.current?.signal);
            return res;
        } catch (error) {
            return undefined;
        }
    };

    // fetch doctor queue
    const fetchDoctorQueue = async (roomId, socketData = null) => {
        try {
            setIsLoading(true);
            const queryParams = {
                roomId,
                queueStatus: queueTypeTab.type === "Hold" ? "2" : "0",
                queueWaitPage: doctorQueue.queueWaitPage,
                queueWaitPerPage: doctorQueue.queueWaitPerPage,
                queueHoldPage: doctorQueue.queueHoldPage,
                queueHoldPerPage: doctorQueue.queueHoldPerPage,
                search: searchQueueText,
                // withoutLoop: false,
            };
            let res = null;
            if (socketData) {
                res = socketData;
            } else {
                res = await getDoctorQueue(queryParams, controllerRef.current?.signal);
            }
            // const patientsWait = calculateDoctorQueueWaitLate(res?.patientsInQueue || []);

            // const filterPatientWait = [];
            // for (let index = 0, len = patientsWait?.length || 0; index < len; index++) {
            //     const item = patientsWait[index];
            //     if (item?.PatientName?.includes(queryParams?.search) || item?.QueueNo?.includes(queryParams?.search)) {
            //         filterPatientWait.push({
            //             ...item,
            //             PatientName: item?.PatientName,
            //             DoctorName: item?.DoctorName,
            //             waitQueue: index,
            //         });
            //     }
            // }
            // const filterPatientHold = [];
            // if (res?.patientHold?.length) {
            //     for (let index = 0, len = res?.patientHold?.length || 0; index < len; index++) {
            //         const item = res?.patientHold[index];
            //         if (
            //             item?.PatientName?.includes(queryParams?.search) ||
            //             item?.QueueNo?.includes(queryParams?.search)
            //         ) {
            //             filterPatientHold.push(item);
            //         }
            //     }
            // }

            if (res) {
                setDoctorQueue(currentState => ({
                    ...currentState,
                    queueWait: queueTypeTab.type === "Wait" ? res?.patientWait : [],
                    queueHold: queueTypeTab.type === "Hold" ? res?.patientHold : [],
                    queueInRoom: {
                        doctorQueueId: res?.patientInRoom?.doctorQueueId || "",
                        QueueNo: res?.patientInRoom?.QueueNo || "",
                        ServingTime: res?.patientInRoom?.ApptTime || "",
                        Service: res?.patientInRoom?.Service || "",
                        Status: res?.patientInRoom?.Status || "",
                        DoctorName: res?.patientInRoom?.DoctorName || "",
                        TypePatient: res?.patientInRoom?.isEmergency || "",
                        PatientName: res?.patientInRoom?.PatientName || "",
                    },
                    totalQueueWait: res?.totalQueueWait || 0,
                    totalQueueHold: res?.totalQueueHold || 0,
                }));
                // setDoctorQueue(currentState => ({
                //     ...currentState,
                //     queueWait:
                //         queueTypeTab.type === "Wait"
                //             ? filterPatientWait.slice(
                //                   0,
                //                   Number(queryParams.queueWaitPage) * Number(queryParams.queueWaitPerPage),
                //               )
                //             : [],
                //     queueHold:
                //         queueTypeTab.type === "Hold"
                //             ? filterPatientHold.slice(
                //                   0,
                //                   Number(queryParams.queueHoldPage) * Number(queryParams.queueHoldPerPage),
                //               )
                //             : [],
                //     queueInRoom: {
                //         doctorQueueId: res?.patientInRoom?.doctorQueueId || "",
                //         QueueNo: res?.patientInRoom?.QueueNo || "",
                //         ServingTime: res?.patientInRoom?.ApptTime || "",
                //         Service: res?.patientInRoom?.Service || "",
                //         Status: res?.patientInRoom?.Status || "",
                //         DoctorName: res?.patientInRoom?.DoctorName || "",
                //         TypePatient: res?.patientInRoom?.isEmergency || "",
                //         PatientName: res?.patientInRoom?.PatientName || "",
                //     },
                //     totalQueueWait: filterPatientWait?.length || 0,
                //     totalQueueHold: filterPatientHold?.length || 0,
                // }));
            }
            setIsLoading(false);
        } catch (error) {
            console.dir(error);
            setIsLoading(false);
        }
    };

    // fetch doctor room
    const fetchRoom = async (building = null, floor = null) => {
        try {
            const queryParams = {
                builingId: building ? building : 0,
                floorId: floor ? floor : 0,
                statusRoom: "0",
            };
            const res = await getQueueRoom(queryParams, controllerRef.current?.signal);
            if (res) {
                setDoctorRoom(res?.data);
                if (res?.data?.length > 0) {
                    setRoomValue({ idx: 0, roomObj: res?.data[0] });
                    handleSelectRoom(0, res?.data[0]);
                } else {
                    setDoctorQueue(initialDoctorQueue);
                }
            }
        } catch (error) {
            console.dir(error);
        }
    };

    // fetch building setting option
    const fetchBuildingSettingOption = async signal => {
        try {
            const buildingSettingOption = await getBuildingSettingOption(signal);
            if (buildingSettingOption) {
                setOption(currentState => ({
                    ...currentState,
                    building: buildingSettingOption?.buildingOption,
                    floor: buildingSettingOption?.floorOption,
                }));
            }
        } catch (error) {
            console.dir(error);
        }
    };

    // update doctor queue
    const handleUpdateDoctorQueueStatus = async value => {
        try {
            const isUpdate = await updateDoctorQueueById(
                value?.id,
                { Status: value?.Status, ActionBy: value?.ActionBy },
                controllerRef.current?.signal,
            );
            if (isUpdate) {
                const res = await getDoctorQueueByRoomId(roomValue?.roomObj?.roomId);
                // socketIO.emit("update-doctor-queue", ["1"].includes(value?.Status) ? "" : "without-voice");
                socketIO.emit(
                    "update-doctor-queue",
                    JSON.stringify({ type: ["1"].includes(value?.Status) ? "" : "without-voice", data: res }),
                );
                forceRender();
            }
        } catch (error) {
            console.dir(error);
            setIsCalling(false);
            setIsHoldingWaitQueue(false);
        }
    };

    // update lab xray
    const handleUpdateLabXray = async value => {
        try {
            const queryParams = {
                DoctorCode: value,
            };
            await getLabAndXray(queryParams);
        } catch (error) {
            console.dir(error);
            setIsCalling(false);
        }
    };

    // select doctor room
    const handleSelectRoom = (idx, roomObj) => {
        setDoctorQueue(initialDoctorQueue);
        setSearchQueueText("");
        if (roomObj) {
            setRoomValue({ idx, roomObj });
        }
    };

    // change tab
    const handleChangeTab = (idx, type) => {
        setDoctorQueue(initialDoctorQueue);
        setSearchQueueText("");
        setQueueTypeTab({ idx, type });
    };

    // search filter
    const handleSearchQueue = search => {
        setSearchQueueText(search);
    };

    // click search
    const handleClickSearch = () => {
        forceRender();
    };

    // clear search
    const handleClearSearch = () => {
        setSearchQueueText("");
        forceRender();
    };

    // select building and floor
    const handleOnchangeDropdown = async (type = "", value = "") => {
        handleSelectRoom(0, {});
        setSearchQueueText("");
        if (type === "building") {
            setIsAllactionDD({ ...isAllactionDD, building: value, floor: "" });
            setDoctorRoom([]);
        } else if (type === "floor") {
            setIsAllactionDD({ ...isAllactionDD, floor: value });
            fetchRoom(isAllactionDD?.building, value);
        }
    };

    // click action button 'hold' and 'close'
    const handleClickActionQueue = async (type, data) => {
        if (type === "hold") {
            Swal.fire({
                title: `<div class="h3 t-text-primary">Want to hold this queue?</div>`,
                iconHtml: '<i class="far fa-clock fa-lg" style="color:inherit;" ></i>',
                iconColor: Color.primary,
                text: "",
                showCancelButton: true,
                confirmButtonColor: Color.primary,
                cancelButtonColor: "#7C7C7C",
                confirmButtonText: "YES",
                cancelButtonText: "NO",
                heightAuto: false,
                customClass: {
                    icon: "border-0 t-icon-show",
                },
            }).then(async result => {
                if (result.isConfirmed) {
                    const updateBody = {
                        id: data?.doctorQueueId,
                        Status: "2",
                        ActionBy: "1", // ฺหมอ
                    };
                    handleUpdateDoctorQueueStatus(updateBody);
                }
            });
        } else if (type === "close") {
            Swal.fire({
                icon: "success",
                title: `<div class="h3 t-text-primary">Want to close this queue?</div>`,
                iconColor: Color.primary,
                text: "",
                showCancelButton: true,
                confirmButtonColor: Color.primary,
                cancelButtonColor: "#7C7C7C",
                confirmButtonText: "YES",
                cancelButtonText: "NO",
                heightAuto: false,
            }).then(result => {
                if (result.isConfirmed) {
                    const updateBody = {
                        id: data?.doctorQueueId,
                        Status: "3",
                        ActionBy: "1", // ฺหมอ
                    };
                    handleUpdateDoctorQueueStatus(updateBody);
                }
            });
        }
    };

    // click call
    const handleClickCall = async (value, index) => {
        setCallingIndex(index);
        setIsCalling(true);
        if (doctorQueue?.queueInRoom?.QueueNo === "") {
            const updateBody = {
                id: value?.doctorQueueId,
                Status: "1",
                ActionBy: "1", // ฺหมอ
            };
            await handleUpdateDoctorQueueStatus(updateBody);
            await handleUpdateLabXray(value?.DoctorCode);
        } else {
            Swal.fire({
                title: `<div class="h3 t-text-primary">The patient is already in the examination room.</div>`,
                iconHtml: '<i class="far fa-clock fa-lg" style="color:inherit;" ></i>',
                iconColor: Color.primary,
                text: "",
                showCancelButton: false,
                confirmButtonColor: Color.primary,
                cancelButtonColor: "#7C7C7C",
                confirmButtonText: "YES",
                heightAuto: false,
                customClass: {
                    icon: "border-0 t-icon-show",
                },
            });
        }
        setIsCalling(false);
    };

    // click hold in wait queue
    const handleClickHoldWaitQueue = async (value, index) => {
        const { isConfirmed } = await Swal.fire({
            title: `<div class="h3 t-text-primary">Want to hold this queue?</div>`,
            iconHtml: '<i class="far fa-clock fa-lg" style="color:inherit;" ></i>',
            iconColor: Color.primary,
            text: "",
            showCancelButton: true,
            confirmButtonColor: Color.primary,
            cancelButtonColor: "#7C7C7C",
            confirmButtonText: "YES",
            cancelButtonText: "NO",
            heightAuto: false,
            customClass: {
                icon: "border-0 t-icon-show",
            },
        });
        if (isConfirmed && value?.doctorQueueId) {
            setHoldingWaitQueueIndex(index);
            setIsHoldingWaitQueue(true);
            const updateBody = {
                id: value?.doctorQueueId,
                Status: "2",
                ActionBy: "1", // ฺหมอ
            };
            await handleUpdateDoctorQueueStatus(updateBody);
        }
        setIsHoldingWaitQueue(false);
    };

    // click recall
    const handleClickRecall = async () => {
        setIsRecalling(true);
        const res = await getDoctorQueueByRoomId(roomValue?.roomObj?.roomId);
        // old -
        // socketIO.emit("update-doctor-queue");
        // new -
        socketIO.emit("update-doctor-queue", JSON.stringify({ type: "", data: res }));
        setTimeout(() => {
            setIsRecalling(false);
        }, 500);
    };

    // click more queue icon
    const handleFetchMoreQueue = () => {
        setDoctorQueue(currentState => ({
            ...currentState,
            queueWaitPage: queueTypeTab.type === "Wait" ? currentState.queueWaitPage + 1 : currentState.queueWaitPage,
            queueHoldPage: queueTypeTab.type === "Hold" ? currentState.queueHoldPage + 1 : currentState.queueHoldPage,
        }));
    };

    useEffect(() => {
        if (roomValue.roomObj?.roomId) {
            fetchDoctorQueue(roomValue.roomObj?.roomId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roomValue, queueTypeTab, doctorQueue.queueWaitPage, doctorQueue.queueHoldPage, render]);

    useEffect(() => {
        if (queueTypeTab.type === "Wait" && doctorQueue?.queueWait?.length !== doctorQueue?.totalQueueWait) {
            setShowMoreIcon(true);
        } else if (queueTypeTab.type === "Hold" && doctorQueue?.queueHold?.length !== doctorQueue?.totalQueueHold) {
            setShowMoreIcon(true);
        } else {
            setShowMoreIcon(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queueTypeTab, doctorQueue.queueWait, doctorQueue.queueHold]);

    // fetch building option data
    useEffect(() => {
        controllerRef.current = new AbortController();
        fetchBuildingSettingOption();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, []);

    // connect socket.io
    useEffect(() => {
        let socket;
        if (roomValue?.roomObj?.roomId) {
            socket = io(`${process.env?.REACT_APP_HOST_SOCKET}/doctor-queue`, {
                transports: ["websocket"],
            });

            socket.on("connect", () => {
                socket.emit("join-doctor-room", roomValue?.roomObj?.roomId);
            });

            socket.on("doctor-queue-from-hch", data => {
                const socketDataObj = parseJsonStr(data);
                if (socketDataObj?.doctorQueueData?.length) {
                    const findDataByRoomId = socketDataObj?.doctorQueueData?.find(
                        data => data?.roomId == roomValue.roomObj?.roomId, // eslint-disable-line eqeqeq
                    );
                    if (findDataByRoomId) {
                        fetchDoctorQueue(roomValue.roomObj?.roomId, findDataByRoomId);
                    }
                }
            });
            setSocketIO(socket);
        }

        return () => {
            if (roomValue?.roomObj?.roomId && socket) {
                socket.off("connect");
                socket.off("doctor-queue-from-hch");
                socket.emit("leave-doctor-room");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roomValue.roomObj]);

    return (
        <div className="d-flex flex-column h-100">
            {/* navbar menu floor and room */}
            <div className="flex-grow-0">
                <Grid container spacing={1} className="justify-content-lg-start mb-5">
                    <Grid item xs={12} md={2}>
                        <SelectDropOtions
                            key={"select_floor"}
                            options={option?.building}
                            useTheme={true}
                            onChange={value => handleOnchangeDropdown("building", value)}
                            value={isAllactionDD?.building}
                            placeholder="Select..."
                            renderOption={row => {
                                return (
                                    <MenuItem key={"floor_" + row.buildingId} value={row.buildingId}>
                                        {" "}
                                        {row.name}{" "}
                                    </MenuItem>
                                );
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <SelectDropOtions
                            key={"select_room"}
                            options={option?.floor.filter(item => item?.buildingId === isAllactionDD?.building)}
                            useTheme={true}
                            onChange={value => handleOnchangeDropdown("floor", value)}
                            value={isAllactionDD?.floor}
                            placeholder="Select..."
                            renderOption={row => {
                                return (
                                    <MenuItem key={"room_" + row.floorId} value={row.floorId}>
                                        {" "}
                                        {row.name} {row.locationName}
                                    </MenuItem>
                                );
                            }}
                        />
                    </Grid>
                </Grid>
            </div>
            <div className="flex-grow-1 d-flex flex-column">
                <div>
                    <Grid container spacing={1} className="justify-content-lg-start">
                        <Grid item xs={12}>
                            <div className="row">
                                <div className="col-12">
                                    <div
                                        className="d-flex align-items-center"
                                        style={{ overflowX: "auto", overflowY: "hidden" }}
                                        onMouseEnter={() => {
                                            setIsEnterSelectRoom(true);
                                        }}
                                        onMouseLeave={() => {
                                            setIsEnterSelectRoom(false);
                                        }}>
                                        {doctorRoom?.map((row, idx) => (
                                            <div key={"room_" + idx} className="col-4 col-sm-3 col-lg-2 px-0">
                                                <div
                                                    className={`${useClass.boxlistRoom} ${
                                                        roomValue.idx === idx ? "active" : ""
                                                    }`}
                                                    style={{ height: isEnterSelectRoom ? 60 : 40 }}
                                                    onClick={() => handleSelectRoom(idx, row)}>
                                                    <p className="text-typo">{row?.name}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                {/* Hold and close */}
                <div style={{ height: 0 }} className="flex-fill">
                    <Paper elevation={1} className="p-5 h-100">
                        <Grid container spacing={2} className="h-100">
                            {/* result show */}
                            <Grid item xs={12} lg={5} className="h-100">
                                <Box
                                    // style={{ height: heightBox }}
                                    className={`h-100 d-flex flex-column justify-content-between text-center shadow-xs rounded rounded-lg overflow-auto ${useClass.boxContentFixed}`}>
                                    {/* <div className={`t-card-title ${useClass.titleCard}`}></div> */}
                                    <div className="flex-fill mb-5 mb-lg-10">
                                        <h3 className="text-muted mb-5">Queue Number </h3>
                                        <h3 className="t-text-primary">{doctorQueue?.queueInRoom?.QueueNo || "-"}</h3>
                                    </div>
                                    <div className="flex-fill mb-5 mb-lg-10">
                                        <h3 className="text-muted mb-5">Patient</h3>
                                        <h3 className="t-text-primary">
                                            {doctorQueue?.queueInRoom?.PatientName || "-"}
                                        </h3>
                                    </div>
                                    <div className="flex-fill mb-5 mb-lg-10">
                                        <h3 className="text-muted mb-5">Serving Time</h3>
                                        <h3 className="t-text-primary">
                                            {doctorQueue?.queueInRoom?.ServingTime || "-"}
                                        </h3>
                                    </div>
                                    <div className="flex-fill mb-5 mb-lg-10">
                                        <h3 className="text-muted mb-5">Service</h3>
                                        <h3 className="t-text-primary">{doctorQueue?.queueInRoom?.Service || "-"}</h3>
                                        <h3 className="t-text-primary">{doctorQueue?.queueInRoom?.DoctorName || ""}</h3>
                                    </div>
                                    <div className="flex-fill mb-5 mb-lg-10">
                                        <h3 className="text-muted mb-5">Status</h3>
                                        <h3 className="t-text-primary">
                                            {doctorQueue?.queueInRoom?.Status === "1" ? "กำลังอยู่ในห้องตรวจ" : "-"}
                                        </h3>
                                        <h3 className="text-danger">
                                            {doctorQueue?.queueInRoom?.TypePatient === "Y" ? "Emergency" : ""}
                                        </h3>
                                    </div>
                                    {doctorQueue?.queueInRoom?.QueueNo ? (
                                        <div className="d-flex justify-content-center align-items-center">
                                            <Button
                                                onClick={handleClickRecall}
                                                className={`t-btn-primary mb-5 mb-lg-10`}
                                                style={{ width: "40%", height: "70%" }}
                                                disabled={isRecalling}>
                                                {isRecalling ? (
                                                    <div
                                                        className="spinner-border"
                                                        style={{ width: "1.5rem", height: "1.5rem" }}
                                                        role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                ) : (
                                                    "Recall"
                                                )}
                                            </Button>
                                        </div>
                                    ) : null}
                                </Box>
                            </Grid>
                            {/* actions */}
                            <Grid item xs={12} lg={2} className="h-100">
                                <div className="h-100 d-flex flex-column justify-content-center align-items-center">
                                    <Button
                                        className={`${useClass.btnAcStatus} active`}
                                        onClick={() => {
                                            handleClickActionQueue("hold", doctorQueue?.queueInRoom);
                                        }}>
                                        Hold
                                    </Button>
                                    <Button
                                        className={`${useClass.btnAcStatus} active`}
                                        onClick={() => {
                                            handleClickActionQueue("close", doctorQueue?.queueInRoom);
                                        }}>
                                        Close
                                    </Button>
                                </div>
                            </Grid>
                            {/* data list */}
                            <Grid item xs={12} lg={5} className="h-100">
                                <Box
                                    className={`h-100 shadow-xs rounded rounded-lg overflow-hidden d-flex flex-column ${useClass.boxContentFixed}`}>
                                    {/* <div className={`t-card-title ${useClass.titleCard}`}>Queue Waiting</div> */}
                                    <div className="d-flex align-items-center">
                                        {["Wait", "Hold"]?.map((row, idx) => (
                                            <div key={"queue_type_" + idx} className="flex-fill">
                                                <div
                                                    className={`${useClass.boxlistQueue} ${
                                                        queueTypeTab.idx === idx ? "active" : ""
                                                    }`}
                                                    onClick={() => handleChangeTab(idx, row)}>
                                                    <p className="text-typo">{row}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="p-5 d-flex justify-content-center align-items-center">
                                        <FormControl className="t-form-group-custom w-100 mr-2">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                type="text"
                                                label="Search Queue"
                                                variant="outlined"
                                                value={searchQueueText}
                                                onChange={e => handleSearchQueue(e.target.value)}
                                            />
                                        </FormControl>
                                        <Button onClick={handleClickSearch} className="t-btn-primary mr-2">
                                            Search
                                        </Button>
                                        <Button onClick={handleClearSearch} className="t-btn-primary">
                                            Clear
                                        </Button>
                                    </div>
                                    <div
                                        style={{ height: 0 }}
                                        className={`flex-fill overflow-auto ${useClass.boxListUserWait}`}>
                                        {(queueTypeTab.type === "Wait"
                                            ? doctorQueue?.queueWait
                                            : doctorQueue?.queueHold
                                        )?.map((row, idx, array) => {
                                            return (
                                                <div key={"list_" + idx}>
                                                    <Card elevation={0} className="border-bottom card-list-users">
                                                        <CardContent className="p-3">
                                                            <div className="row">
                                                                <div className="col-7">
                                                                    <p className="mb-2">
                                                                        {row?.PatientName} ({row?.QueueNo})
                                                                    </p>
                                                                    <p className="text-danger mb-2">
                                                                        {row?.isEmergency === "Y" ? "Emergency" : ""}
                                                                    </p>
                                                                    <p className="t-text-orange mb-2">
                                                                        {row?.Status === "2" ? "Status : Hold" : ""}
                                                                    </p>
                                                                    <p
                                                                        className={`${
                                                                            row?.Status === "2"
                                                                                ? "t-text-orange"
                                                                                : "t-text-primary"
                                                                        }  mb-2`}>
                                                                        {row?.DoctorName}
                                                                    </p>
                                                                    <p
                                                                        className={`${
                                                                            row?.Status === "2"
                                                                                ? "t-text-orange"
                                                                                : "t-text-primary"
                                                                        }  mb-2`}>
                                                                        {row?.Service}
                                                                    </p>
                                                                    <p className="mb-2 d-flex align-items-center">
                                                                        {row?.StatusLab
                                                                            ? `Lab: ${
                                                                                  row?.StatusLab === "0"
                                                                                      ? "ไม่มีการตรวจ"
                                                                                      : row?.StatusLab === "1"
                                                                                      ? "รอผลตรวจ"
                                                                                      : "ผลตรวจครบ"
                                                                              }`
                                                                            : ""}
                                                                    </p>
                                                                    <p className="mb-2 d-flex align-items-center">
                                                                        {row?.StatusLab
                                                                            ? `Xray: ${
                                                                                  row?.StatusXray === "0"
                                                                                      ? "ไม่มีการตรวจ"
                                                                                      : row?.StatusXray === "1"
                                                                                      ? "รอผลตรวจ"
                                                                                      : "ผลตรวจครบ"
                                                                              }`
                                                                            : ""}
                                                                    </p>
                                                                </div>
                                                                <div className="col-5">
                                                                    <div className="d-flex align-items-center">
                                                                        <div className="flex-grow-1 mr-2">
                                                                            <div className=" d-flex align-items-center">
                                                                                <Button
                                                                                    onClick={() =>
                                                                                        handleClickCall(row, idx)
                                                                                    }
                                                                                    className="t-btn-primary w-100 mr-1 mb-2"
                                                                                    disabled={isCalling}>
                                                                                    {isCalling &&
                                                                                    callingIndex === idx ? (
                                                                                        <div
                                                                                            className="spinner-border"
                                                                                            style={{
                                                                                                width: "1.5rem",
                                                                                                height: "1.5rem",
                                                                                            }}
                                                                                            role="status">
                                                                                            <span className="sr-only">
                                                                                                Loading...
                                                                                            </span>
                                                                                        </div>
                                                                                    ) : (
                                                                                        "Call"
                                                                                    )}
                                                                                </Button>
                                                                                {row?.Status !== "2" ? (
                                                                                    <Button
                                                                                        onClick={() =>
                                                                                            handleClickHoldWaitQueue(
                                                                                                row,
                                                                                                idx,
                                                                                            )
                                                                                        }
                                                                                        className="t-btn-primary w-100 mr-1 mb-2"
                                                                                        disabled={
                                                                                            isHoldingWaitQueue ||
                                                                                            isCalling
                                                                                        }>
                                                                                        {isHoldingWaitQueue &&
                                                                                        holdingWaitQueueIndex ===
                                                                                            idx ? (
                                                                                            <div
                                                                                                className="spinner-border"
                                                                                                style={{
                                                                                                    width: "1.5rem",
                                                                                                    height: "1.5rem",
                                                                                                }}
                                                                                                role="status">
                                                                                                <span className="sr-only">
                                                                                                    Loading...
                                                                                                </span>
                                                                                            </div>
                                                                                        ) : (
                                                                                            "Hold"
                                                                                        )}
                                                                                    </Button>
                                                                                ) : null}
                                                                            </div>

                                                                            <div className="text-muted d-flex align-items-center justify-content-center">
                                                                                {/* <PeopleIcon /> */}
                                                                                <div className="mr-2">
                                                                                    จำนวนคิวที่รอ
                                                                                </div>
                                                                                <div>
                                                                                    {queueTypeTab.type === "Wait"
                                                                                        ? row?.waitQueue || 0
                                                                                        : 0}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <small className="text-muted d-flex align-items-center justify-content-between">
                                                                                <AccessTime />
                                                                                <div>{row?.ApptTime}</div>
                                                                            </small>
                                                                            <small className="text-muted d-flex align-items-center justify-content-between">
                                                                                <DirectionsRun />
                                                                                <div>{row?.ArriveTime}</div>
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardContent>
                                                    </Card>
                                                    {idx === array.length - 1 &&
                                                        showMoreIcon &&
                                                        (isLoading ? (
                                                            <div className="d-flex justify-content-center align-items-center py-5">
                                                                <div className="spinner-border" role="status">
                                                                    <span className="sr-only">Loading...</span>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className="w-100 d-flex justify-content-center align-items-center load-more-data"
                                                                onClick={handleFetchMoreQueue}>
                                                                <ExpandMoreIcon style={{ fontSize: 50 }} />
                                                            </div>
                                                        ))}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                </div>
            </div>
        </div>
    );
}

export default QueueManagement;
